import {Component, OnInit} from '@angular/core';
import {MercadoriasEmbalagensService} from "./mercadorias-embalagens.service";
import {MercadoriasEmbalagensModel} from "./mercadorias-embalagens.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {TranslateService} from '@ngx-translate/core';
import {LoginService} from "../login/login.service";

declare let swal: any;

@Component({
  selector: 'app-mercadorias-embalagens',
  templateUrl: './mercadorias-embalagens.component.html'
})
export class MercadoriasEmbalagensComponent extends Components implements OnInit {

  embalagens: MercadoriasEmbalagensModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private mercadoriasEmbalagensService: MercadoriasEmbalagensService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'mercadorias'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.mercadoriasEmbalagensService.getPaginacao(1,this.itensPorPagina, ["mercadoria"])
      .subscribe(data => {
        this.embalagens = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.embalagens);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });


  }

  delete(embalagem) {
    let embalagens = this.embalagens;
    let mercadoriasEmbalagensService = this.mercadoriasEmbalagensService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarEmbalagem')+embalagem.nome_pt,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(embalagens);
        }

        let index = embalagens.indexOf(embalagem);
        embalagens.splice(index, 1);

        mercadoriasEmbalagensService.apagar(embalagem.id_embalagem)
          .subscribe(res => {
              self.embalagens = embalagens;
            },
            err => {
              // Revert the view back to its original state
              embalagens.splice(index, 0, embalagem);
              self.embalagens = embalagens;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.mercadoriasEmbalagensService.getPaginacao(pagina,this.itensPorPagina)
      .subscribe(data => {
        this.embalagens = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/mercadorias-embalagens/mercadorias-embalagens.component.ts